import * as yup from "yup";

export const loginSchema = yup.object().shape({
    username: yup
        .string()
        // .email("Напишите правильный адрес электронной почты")
        .required('Это обязательное поле'),
    password: yup
        .string()
        .required('Это обязательное поле'),
})